const dataList = [
   {  name:"sub1",  path: '/' ,chineseName:'首页'},
   {  name:"qx1",  path: '/powerManage',chineseName:'权限管理'},
   {  name:"qx2",  path: '/managerList',chineseName:'管理员列表'},
   {  name:"rw1",  path: '/taskManage/taskList',chineseName:'任务管理/任务列表'},
   {  name:"taskAppeal",  path: '/taskManage/taskAppeal',chineseName:'任务管理/任务申诉处理'},
   {  name:"pointsExpand",  path: '/pointsManage/pointsExpand',chineseName:'积分管理/推广积分管理'},
   {  name:"pointsMember",  path: '/pointsManage/pointsMember',chineseName:'积分管理/会员积分管理'},
   {  name:"pointsUser",  path: '/pointsManage/pointsUser',chineseName:'积分管理/用户积分详情'},
   {  name:"cw1",  path: '/financeManage/income',chineseName:'财务管理/收入与扣税台账'},
   {  name:"cw2",  path: '/financeManage/withdraw',chineseName:'财务管理/提现与资金流水'},
   {  name:"cw3",  path: '/financeManage/vat',chineseName:'财务管理/增值税代办台账'},
   {  name:"cw4",  path: '/financeManage/auth',chineseName:'财务管理/授权存证管理'},
   {  name:"cw5",  path: '/financeManage/order',chineseName:'财务管理/平台订单明细'},
   {  name:"rwxq",  path: '/taskManage/taskList/taskDetail',chineseName:'任务管理/任务列表/任务详情'},
]
export default dataList;